export default [
    { key: 'serial', label: 'Serial' },
    { key: 'item_type.name', label: 'Tipo' },
    { key: 'item_sub_type.name', label: 'Subtipo' },
    { key: 'item_brand.name', label: 'Marca' },
    { key: 'price', label: 'Precio' },
    { key: 'sim_card_number', label: 'Número Sim' },
    { key: 'actions', label: 'Acciones' },
]
